let contactSidebar = document.querySelector('.contact-sidebar');
let newsletterSidebar = document.querySelector('.newsletter-sidebar');
let joinSidebar = document.querySelector('.join-sidebar'); // Incubator application
let clusterSidebar = document.querySelector('.cluster-sidebar'); // Cluster application
let hubSidebar = document.querySelector('.hub-sidebar'); // Cluster application

let contactToggle = document.querySelectorAll('.js-contact-toggle');
let newsletterToggle = document.querySelectorAll('.js-newsletter-toggle');
let joinToggle = document.querySelectorAll('.js-join-toggle');
let clusterToggle = document.querySelectorAll('.js-cluster-toggle');
let hubToggle = document.querySelectorAll('.js-hub-toggle');

let contactClose = document.querySelector('.js-contact-close');
let newsletterClose = document.querySelector('.js-newsletter-close');
let joinClose = document.querySelector('.js-join-close');
let clusterClose = document.querySelector('.js-cluster-close');
let hubClose = document.querySelector('.js-hub-close');

let body = document.querySelector('body');
let main = document.querySelector('.main');

if (contactToggle) {
    contactToggle.forEach(el => {
        el.addEventListener('click', () => {
            contactSidebar.classList.toggle('contact-sidebar-open');
            body.classList.toggle('scrollock')
        });
    })
}

if (contactClose) {
    contactClose.addEventListener('click', () => {
        contactSidebar.classList.toggle('contact-sidebar-open');
        body.classList.toggle('scrollock')
    });
}

if (newsletterToggle) {
    newsletterToggle.forEach(el => {
        el.addEventListener('click', () => {
            newsletterSidebar.classList.toggle('newsletter-sidebar-open');
            body.classList.toggle('scrollock')
        });
    });
}
if (newsletterClose) {
    newsletterClose.addEventListener('click', () => {
        newsletterSidebar.classList.toggle('newsletter-sidebar-open');
        body.classList.toggle('scrollock')
    });
}

if (joinToggle) {
    joinToggle.forEach(el => {
        el.addEventListener('click', () => {
            joinSidebar.classList.toggle('join-sidebar-open');
            body.classList.toggle('scrollock')
        });
    })
}

if (joinClose) {
    joinClose.addEventListener('click', () => {
        joinSidebar.classList.toggle('join-sidebar-open');
        body.classList.toggle('scrollock')
    });
}

if (clusterToggle) {
    clusterToggle.forEach(el => {
        el.addEventListener('click', () => {
            clusterSidebar.classList.toggle('cluster-sidebar-open');
            body.classList.toggle('scrollock')
        });
    })
}

if (clusterClose) {
    clusterClose.addEventListener('click', () => {
        clusterSidebar.classList.toggle('cluster-sidebar-open');
        body.classList.toggle('scrollock')
    });
}

if (hubToggle) {
    hubToggle.forEach(el => {
        el.addEventListener('click', () => {
            hubSidebar.classList.toggle('hub-sidebar-open');
            body.classList.toggle('scrollock')
        });
    })
}

if (hubClose) {
    hubClose.addEventListener('click', () => {
        hubSidebar.classList.toggle('hub-sidebar-open');
        body.classList.toggle('scrollock')
    });
}


